// extracted by mini-css-extract-plugin
export default {"toggleContainer":"ToggleContent_toggleContainer__RE6qz","toggle":"ToggleContent_toggle__GgOPW"};